<mat-card>
  <mat-card-content>
    <span>{{ 'page.forbidden.description' | translate }}</span>
  </mat-card-content>
</mat-card>
